/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestData} from '../api'

 export const useQueryGetInterestData = createReactQueryHook('getInterestData', getInterestData)
